import * as React from "react";
import HandleUIError from "../../utils/HandleUIError";
import toast from "react-hot-toast";

//components
import {
  Modal,
  Input,
  Button,
  Spinner,
  IconButton,
} from "../atomics";
import { cilX } from "@coreui/icons";
import { User, UserData } from '../../services/types';
import { updatedAdmin } from "../../services/AdminServices";
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { useAppSelector } from "../../redux/hooks";
import { emailVerification, otpVerification } from "../../services/AuthSettingService";
import { useHistory } from "react-router-dom";

interface Props {
  visible: boolean;
  closeModal: () => void;
  refreshAdmins: () => void;
  user: User
  organizationId: number;
}

const EditAdmin: React.FC<Props> = ({ visible, closeModal, refreshAdmins, user, organizationId }) => {
  const [firstName, setFirstName] = React.useState<string>(user.firstName);
  const [lastName, setLastName] = React.useState<string>(user.lastName);
  const [userEmail, setUserEmail] = React.useState<string>(user.email);
  const [phone, setPhone] = React.useState<string>(user.phone);
  const [password, setPassword] = React.useState<string | null>(null);
  const [addUserLoading, setAddUserLoading] = React.useState<boolean>(false);
  const [sendOtpField, setSendOtpField] = React.useState<boolean>(false)
  const [hideButton, setHideButton] = React.useState<boolean>(true)
  const [otp, setOtp] = React.useState()
  const userSlice = useAppSelector((state) => state.UserSlice);


  const loginEmail = userSlice.user.email;
  const history = useHistory()

  var pattern = new RegExp(
    /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
  );

  const handleInputFirstName = (e: any) => {
    setFirstName(e.target.value);
  };

  const handleInputLastName = (e: any) => {
    setLastName(e.target.value);
  };

  const handleInputMail = (e: any) => {
    setUserEmail(e.target.value);
  };

  const handleInputPhone = (e: any) => {
    setPhone(e.target.value);
  };

  const handleInputPassword = (e: any) => {
    setPassword(e.target.value);

    if (e.target.value.length > 0) {
      setHideButton(false);
    } else {
      setHideButton(true);
      setSendOtpField(false)
    }
  };

  async function updateUser(firstName: string, lastName: string, email: string, phone: string, password?: string | null): Promise<void> {

    if (!pattern.test(email)) {
      toast.error("Please enter valid email address")
      return

    } else {
      try {
        setAddUserLoading(true);

        if (email === "" || email === null) {
          toast.error("Email cannot be empty")
          setAddUserLoading(false);
        } else {
          let userData: UserData | null;
          if (password !== null) {
            userData = {
              "firstName": firstName,
              "lastName": lastName,
              "email": email,
              "phone": phone,
              "password": password
            }
          } else {
            userData = {
              "firstName": firstName,
              "lastName": lastName,
              "email": email,
              "phone": phone
            }
          }
          await updatedAdmin(organizationId, user.id, userData);
          await refreshAdmins();
          toast.success("Admin updated succesfully");
          setAddUserLoading(false);
          closeModal();
        }
      } catch (e) {
        setAddUserLoading(false);
        toast.error("Error updating admin. Try again.")
        HandleUIError(e);
      }
    }

  }




  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (loginEmail === '') {
      toast.error("Please Enter Email");
      return;
    }
    if (!pattern.test(loginEmail)) {
      toast.error("Please Enter Valid Email Address")
      return;
    }

    try {
      const res = await emailVerification({ email: loginEmail });
      // setLoading(false)
      if (res?.data?.status === "success") {
        toast.success("Reset password email sent successfully");
        setSendOtpField(true)
        // history.push("/reset-password")
      }
      else if (res?.data?.status === "error") {
        toast.error(res?.data?.message);
        setSendOtpField(false)

      }
    } catch (e) {
      // toast.error(e?.data?.message);
      // setLoading(false);
      HandleUIError(e);
    }
  };

  const handleOtp = (e: any) => {
    setOtp(e.target.value)

    if (e.target.value.length < 4) {
      setHideButton(false);
    }
  }

  const handleMatchOtp = async (e: any) => {
    e.preventDefault();
    if (otp == "") {
      toast.error("Please Enter OTP");
      return;
    }
    //@ts-ignore
    if (otp?.length < 4) {
      toast.error("Otp must be of 4 digits");
      return;
    }

    try {
      const res = await otpVerification({ email: loginEmail, otp });
      if (res?.data?.status === "success") {
        toast.success(res?.data?.message);
        // history.push('/new-password')
        setHideButton(true);
        setSendOtpField(false)
      } else if (res?.data?.status === "error") {
        toast.error(res?.data?.message);
      }
    } catch (e) {
      // setLoading(false);
      HandleUIError(e);
    }

  };



  return (
    <Modal visible={visible} >
      <div className="edit-user-container">
        <div className="edit-user-header">
          <p className="text-light py-2 ps-4 fs-5">Edit admin</p>
          <IconButton icon={cilX} className="me-3" onClick={closeModal} />
        </div>

        <div className="row g-0 mx-3 users-container">

          <div className="col-6">
            <p className="text-light fs-5  pt-3">
              First Name
            </p>
            <Input
              className="mt-2 mb-3  search-phone-input"
              onChange={handleInputFirstName}
              defaultValue={firstName}
              autoFocus
            />
          </div>
          <div className="col-6">
            <p className="text-light fs-5  pt-3">
              Last Name
            </p>
            <Input
              className="mt-2 mb-3  search-phone-input"
              onChange={handleInputLastName}
              defaultValue={lastName}
            />
          </div>
          <div className="col-6">
            <p className="text-light fs-5  pt-3">
              Email
            </p>
            <Input
              className="mt-2 mb-3  search-phone-input"
              onChange={handleInputMail}
              defaultValue={userEmail}
            />
          </div>

          <div className="col-6">
            <p className="text-light fs-5  pt-3">
              Phone
            </p>
            <PhoneInput
              value={phone}
              className="me-2 mt-2 bg-transparent "
              onChange={(e: any) => { setPhone(e) }}
            />
          </div>

          <div className="col-12">

            <p className="text-light fs-5  pt-3">
              Password
            </p>

            <div className="row">
              <div className="col">


                <Input
                  type="password"
                  className="mt-2 search-phone-input"
                  onChange={handleInputPassword}
                />
              </div>
              {
                // @ts-ignore
                password?.length > 0 && (
                  <div className="col-auto me-4">

                    <button type="button" onClick={handleSubmit} className="btn mt-2 btn-primary">
                      Send OTP
                    </button>
                  </div>
                )}
            </div>




            {
              // @ts-ignore
              sendOtpField && password?.length > 0 && (
                <>
                  <p className="text-light fs-5 ms-3 pt-3">
                    OTP
                  </p>
                  <div className="row">
                    <div className="col">
                      <Input
                        className="mt-2 mb-3 ms-3 search-phone-input"
                        onChange={handleOtp}
                        defaultValue={otp}
                        maxLength={4}
                        type="number"
                      />
                    </div>

                    <div className="col-auto mt-2">
                      <button onClick={handleMatchOtp} className="btn btn-primary d-flex align-items-center" style={{ height: "2.2rem" }}>
                        Verify
                      </button>
                    </div>
                    <div className="col-auto me-3 mt-2">
                      <button onClick={handleSubmit} className="btn btn-primary d-flex align-items-center py-0" style={{ height: "2.2rem" }}>
                        Resend OTP
                      </button>
                    </div>
                  </div>
                </>
              )}
          </div>








          <p className="text-warning ms-3 mb-3">*** Only modify if you want to change the password ***</p>

          <div className="d-flex justify-content-center">

            {hideButton && (
              <Button
                disabled={addUserLoading}
                className="mt-7 button-add px-4 mb-3"
                onClick={() => {
                  updateUser(firstName, lastName, userEmail, phone, password)
                }}
              >
                {!addUserLoading ? "Save" : <Spinner />}
              </Button>
            )}

          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditAdmin;